export default {
  DEFAULT: '#C6E1DC',
  PINK: '#e550a7',
  BLUE: '#5d42e5',
  YELLOW: '#ba8e00',
};



// WEBPACK FOOTER //
// ./src/constants/ThemeColors.js